import React, { useEffect, useRef, useState } from 'react';
import sImageViewer from './ImageViewer.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ScreenReaderHeadingComponent from '../../sites/travelerProfile/components/heading/ScreenReaderHeadingComponent/index.js';
import Modal from 'react-bootstrap/Modal';
import closeIcon from '../../shared/images/close.png';

function ImageViewer(props) {
  const [isError, setIsError] = useState(false);
  const modalRef = useRef(null);
  useEffect(() => {
    document.getElementById("preview-close-button").setAttribute("tabindex", "0");
    document.getElementById("preview-close-button").focus(); 
  }, []); 

  useEffect(() => {
    if (props.show && modalRef.current) {
      modalRef.current.focus();
    }
  }, [props.show]);  

  return (
    <Modal
      show={props.show}
      onHide={() => {
        props.handleClose();
      }}
      aria-label='Preview Attachment'
    >
      <div
      ref={modalRef}
      role="dialog"
      tabIndex="-1">
      <Modal.Header className={sImageViewer.modelHeader}>
        <div>
          <Modal.Title>Preview</Modal.Title>
          <ScreenReaderHeadingComponent text="Preview" />
        </div>

        <div>
          <button
            id="preview-close-button"
            type="button"
            tabIndex={0}
            className={sImageViewer.modelCloseBtn}
            onClick={() => {
              props.handleClose();
            }}
          >
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
      </Modal.Header>

      <Modal.Body>
        {!isError && (
          <div className={sImageViewer['react-pdf']}>
            <img src={props.file} className={sImageViewer.previewImg} onError={e => setIsError(true)} alt="Application Attachment Preview" />
          </div>
        )}
        {isError && <div className={sImageViewer['react-pdf']}>Unable to load image</div>}
      </Modal.Body>
      </div>  
    </Modal>
  );
}

export default withStyles(sImageViewer)(ImageViewer);